import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const ComparativeAnalyticsPage = lazy(() =>
  import('../pages/analytics/ComparativeAnalyticsPage').then((m) => ({ default: m.ComparativeAnalyticsPage }))
)

export const analyticsRoutes: RouteObject[] = [
  {
    path: '/analytics',
    children: [
      { index: true, element: <ComparativeAnalyticsPage /> },
      { path: 'comparatif', element: <ComparativeAnalyticsPage /> },
      { path: 'reporting', element: <ComparativeAnalyticsPage /> },
    ],
  },
]
